import { Component } from 'react';
import request from 'utils/request_ajax';

class AskTheExpertProvider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requestSent: false,
      requestSending: false,
      question: '',
    };

    this.updateQuestion = this.updateQuestion.bind(this);
    this.submitQuestion = this.submitQuestion.bind(this);
  }

  updateQuestion(question) {
    this.setState({ question });
  }

  submitQuestion() {
    this.setState({ requestSending: true });
    request
      .postJSON(this.props.endpoint, { message: this.state.question })
      .then(() => {
        this.setState({ requestSending: false, requestSent: true });
      })
      .fail(() => {
        this.setState({ requestSending: false });
      });
  }

  render() {
    return this.props.children({
      question: this.state.question,
      updateQuestion: this.updateQuestion,
      submitQuestion: this.submitQuestion,
      requestSending: this.state.requestSending,
      requestSent: this.state.requestSent,
    });
  }
}

export default AskTheExpertProvider;
